const wsUrl = function () {
  return process.env.NODE_ENV === 'production' ? 'wss://nibi.com.co' : 'ws://localhost:5000';
};

const apiUrl = wsUrl();

export default apiUrl;
